import { Button, Card } from "@material-ui/core";
import BusinessIcon from '@material-ui/icons/Business';
import HomeIcon from '@material-ui/icons/Home';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import StoreIcon from '@material-ui/icons/Store';
import { LegendItem, LegendLabel, LegendOrdinal } from '@visx/legend';
import { scaleOrdinal } from "@visx/scale";
import React from "react";
import { LargeColor, ResidentialColor, SettingChoices, SMEColor } from "../consts";

export function CustomLegend(props: { currStep: SettingChoices, marketsActive: boolean, updateFilters: Function }) {
    function legendScale(setting: SettingChoices): any {
        if (setting === "RawYearComparison") {
            return (
                scaleOrdinal({
                    domain: ["Residential", "Business", "Industrial"],
                    range: [ResidentialColor, SMEColor, LargeColor],
                })
            )
        }
        else if (setting === "YoYTotal") {
            return (
                scaleOrdinal({
                    domain: ["Residential", "Business", "Industrial"],
                    range: [ResidentialColor, SMEColor, LargeColor],
                })
            )
        }
        else if (setting === "YoYMarketRegion") {
            return (
                scaleOrdinal({
                    domain: ["Residential Metropolitan", "Residential Regional", "Business Metropolitan", "Business Regional", "Industrial Metropolitan", "Industrial Regional"],
                    range: [ResidentialColor, ResidentialColor, SMEColor, SMEColor, LargeColor, LargeColor],
                })
            )
        }
        else {
            return undefined
        }
    }

    function legendIcon(setting: SettingChoices, color: string, label: string, lineDash = false) {
        if (setting === "YoYTotal" || setting === "RawYearComparison") {
            if (label === "Residential") { return (<HomeIcon htmlColor={color} fontSize={'large'} />) }
            else if (label === "Business") { return (<StoreIcon htmlColor={color} fontSize={'large'} />) }
            else if (label === "Industrial") { return (<BusinessIcon htmlColor={color} fontSize={'large'} />) }
            else if (label === "Overall") { return (<MoreHorizIcon htmlColor={color} fontSize={'large'} />) }
        }
        else {
            if (label.includes("Regional")) {
                return (<svg width={25} height={25}> <line x1="0" y1="12" x2="25" y2="12" stroke={color} stroke-dasharray="4" /> </svg>)
            }
            else {
                return (<svg width={25} height={25}> <line x1="0" y1="12" x2="25" y2="12" stroke={color} /> </svg>)
            }
        }
    }


    if (!legendScale(props.currStep) || props.currStep === "Intro") {
        return null;
    }
    else if (!props.marketsActive) {
        return (
            <Card style={{ zIndex: 1, position: 'fixed', top: "15vh", right: "10vw" }}>
                <Button variant="contained" color="primary" onClick={(e) => { props.updateFilters() }} style={{ marginTop: "5%" }}> Show Market Types </Button>
            </Card>
        )
    }
    else {
        return (
            <Card style={{ zIndex: 1, position: 'fixed', top: "15vh", right: "10vw" }}>
                <LegendOrdinal scale={legendScale(props.currStep)} labelFormat={(label: any) => `${label}`}>
                    {labels => (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {labels.map((label, i) => (
                                <LegendItem key={`legend-quantile-${i}`} margin="5px 5px" >
                                    {legendIcon(props.currStep, label.value, label.text)}
                                    <LegendLabel align="left" margin="0 0 0 4px"> {label.text} </LegendLabel>
                                </LegendItem>
                            ))}
                        </div>
                    )}
                </LegendOrdinal>
            </Card>
        )
    }
}

